<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :has-buttons="false"
    has-validation
    :is-form-fetched="isFormFetched"
  >
    <template #[`uldkAttributes.input`]="data">
      <v-col cols="12">
        <uldk-attributes-mapping-settings v-bind="data" />
      </v-col>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
import UldkAttributesMappingSettings from '@/components/UldkAttributesMappingSettings';

export default {
  name: 'UldkToolsSettings',
  components: {
    AdminWrapper,
    UldkAttributesMappingSettings,
  },
  data: () => ({
    isFormFetched: false,
  }),
  computed: {
    uldkToolsAttributesMappings: get('search/uldkToolsAttributesMappings'),
    additionalModuleName: get('admin/additionalModules@ULDK_TOOLS_MODULE.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@uldk_tools_module_enabled'),
    moduleEnabler() {
      return {
        name: 'uldk_tools_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    inputs() {
      return [
        {
          name: 'uldkAttributes',
          translationPath: 'admin.parcelsUldk.attributesMapping',
          isNamedSlot: false,
          mappingItems: this.uldkToolsAttributesMappings,
          mappingListeners: {
            add: this.addUldkToolsAttributesMapping,
            delete: this.deleteUldkToolsAttributesMapping,
            edit: this.editUldkToolsAttributesMapping,
            get: this.getUldkToolsAttributesMappings,
          },
        },
      ];
    },
  },
  methods: {
    getDatasourceSettings: call('datasourceSettings/getDatasourceSettings'),
    editDatasourceSettings: call('datasourceSettings/editDatasourceSettings'),
    editSingleSetting: call('admin/editSingleSetting'),
    getDataSources: call('layers/getLayersMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    ...call('search/*UldkToolsAttributes*'),

    async editSingleSettingHandler(value, name) {
      if (name === 'parcels_provider') {
        this.editSingleSetting({
          key: name,
          body: {
            value,
          },
        });
      } else {
        return;
      }
    },
    async init() {
      await Promise.all([this.getDataSources({ with_attributes_schema: true })]);
      this.isFormFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
